export const INSERT_FORM_FIRST_INPUT_NAME = 'insert-form-first-input'
export const INSERT_FORM_SECOND_INPUT_NAME = 'insert-form-second-input'
